<template>
    <el-dialog
        width="600px"
        :title="title"
        :visible.sync="visible"
        :before-close="handleClose">

        <el-form ref="formData" :model="formData" label-width="150px" :rules="rules">
            <el-form-item label="SKU：" prop="skuAll">
                <div style="display: flex; align-items: center">
                    <el-input
                        v-model="formData.skuAll"
                        style="width: 400px;margin-right:20px;"
                        placeholder="请输入SKU"
                    ></el-input>
                    <el-button icon="el-icon-search" type="primary" @click="submitForm('formData')" :loading="loading"
                               size="mini" style="height: 35px">查询
                    </el-button>
                </div>
            </el-form-item>
        </el-form>
        <el-table
            v-loading="loading"
            :data="list"
            class="table_content"
            size="mini"
            height="400"
            border
            style="width: 100%;">
            <el-table-column
                label="SKU"
                :resizable="false"
                prop="sku"
                align="center">
            </el-table-column>
            <el-table-column
                label="双/箱"
                :resizable="false"
                prop="specification"
                align="center">
            </el-table-column>
        </el-table>
    </el-dialog>
</template>

<script>
    import * as api from '@/api/advAnalys/advAnalys'

    export default {
        name: 'listBoxGaugeModal',
        data() {
            return {
                loading: false,
                list: [],
                obj: {},
                disabled: false,
                filesize: 0,
                value: '',
                file_data: null,
                formData: {},
                rules: {
                    skuAll: [
                        {
                            required: false,
                            message: '请输入SKU',
                            trigger: 'blur'
                        }
                    ]
                }
            }
        },
        props: {
            visible: {
                type: Boolean,
                default: false
            },
            title: {
                type: String,
                default: ''
            },
            us_arr: {
                type: Array,
                default: () => []
            },
        },
        mounted() {
            this.out_of_stock_analysis_get_box_specification_list()
        },
        methods: {
            // 保存信息
            submitForm(formData) {
                this.$refs[formData].validate(valid => {
                    if (valid) {
                        this.loading = true
                        this.formData.sku = this.formData.skuAll
                            .trim()
                            .replace(/\r\n/g, ',')
                            .replace(/\r/g, ',')
                            .replace(/\n/g, ',')
                            .replace(/,{2,}/g, ',')
                            .replace(/ /g, '')
                        this.out_of_stock_analysis_get_box_specification_list()
                    } else {
                        this.$message({
                            type: 'error',
                            message: '请填写相应内容！'
                        })
                    }
                })
            },
            out_of_stock_analysis_get_box_specification_list() {
                api.out_of_stock_analysis_get_box_specification_list(this.formData).then(res => {
                    if (res.code === 0) {
                        this.list = res.data
                    } else {
                        this.$message({type: 'error', message: res.message})
                    }
                }).catch(() => {
                    this.$message({type: 'error', message: '网络出现错误，请刷新页面后，再次尝试！'})
                }).finally(() => {
                    this.loading = false
                })
            },
            // 关闭弹窗
            handleClose(isshow) {
                this.$refs['formData'].resetFields()
                this.loading = false
                this.$emit('close-callback', isshow)
            }
        }
    }
</script>
